module.exports = __webpack_public_path__ + "webfolder/assets/ebook/ytt-magazine/img/people.361e974d.svg";